export const IClassNameRepository = {
  getClassName: () => { throw new Error('getClassName is not implemented'); }
};
